import type { TypedDocumentNode } from '@urql/core';

import { gql } from '@/shared/types/gql';

import type { EnpsPendingSurveyQuery, EnpsPendingSurveyVars } from '../types';

export const ENPS_PENDING_SURVEY: TypedDocumentNode<EnpsPendingSurveyQuery, EnpsPendingSurveyVars> =
  gql`
    query EnpsPendingSurvey {
      investbanq {
        enps {
          pendingSurvey {
            year
            quarter
            minScore
            maxScore
            commentMaxLength
          }
        }
      }
    }
  `;
